import { message } from 'antd'
import DocumentsApi from '../../../api/Documents'
import Email from '../../../api/Email'
import { RemittanceApi } from '../../../api/Sales/Remittances'
import { VouchersApi } from '../../../api/Purchase/Vouchers'
import Templates from '../../../api/Templates'
import Remittance from '../../../components/Purchasing/Remittance/Remittance'
import useModalShow from '../../../elements/Hooks/useModalShow'
import useSelectionTable from '../../../elements/Hooks/useSelectionTable'
import useSubmit from '../../../elements/Hooks/useSubmit'
import { get, isEmpty, pick } from 'lodash'
import React, { useState } from 'react'

import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import { withRouter } from 'react-router-dom'
import useTitle from '../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

const docsApi = new DocumentsApi()
const templateApi = new Templates()
const emailApi = new Email()

function RemittanceCont(props) {
  const { list: cached, fetching, fetch } = useFetchList(RemittanceApi.list)
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching, 'from.payor')

  const {
    list: cachedPaymentRequestList,
    fetching: paymentRequestFetching,
    fetch: paymentRequestFetch,
  } = useFetchList(() => VouchersApi.listPaymentRequest())
  const {
    list: paymentRequestList,
    company: paymentRequestCompany,
    onChangeCompany: paymentRequestOnChangeCompany,
  } = useListCompanyFilter(cachedPaymentRequestList, paymentRequestFetching)

  const {
    visible,
    modalType,
    object: remittance,
    setObject: setRemittance,
    setSubmitting,
    submitting,
    checkForm,
    // submit,
    update,
    remove,
    removing,
    formRef,
    onShow,
    onCancel,
  } = useModalData(undefined, RemittanceApi.update, RemittanceApi.remove, fetch)

  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await RemittanceApi.create({
        ...newObject,
        paymentRequest: selection,
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('remittance', remittance.status),
    [remittance.status, isEmpty(remittance.status)]
  )

  const [submittingOperation, submitOperation] = useSubmit(RemittanceApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const ObjectDB = await submitOperation({
      status: operation,
      ...pick(remittance, ['_key', '_rev', '_id']),
    })
    if (ObjectDB) setRemittance(ObjectDB)
    hide()
  }

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingRemittanceTemplate, submitRemittanceTemplate] = useSubmit(emailApi.remittanceTemplate, true)
  const [submittingRemittanceFiles, submitRemittanceFiles] = useSubmit(RemittanceApi.files, true)
  const [gettingListLine, getListLine] = useSubmit(RemittanceApi.getLinesByRemittances, true)
  const [gettingVoucher, getVoucher] = useSubmit(VouchersApi.get, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    const listLine = await getListLine(remittance._key)
    const voucher = await getVoucher(get(listLine, '[0]voucher._id').replace('vouchers', ''))
    console.log({ voucher, listLine })
    const company = get(remittance, 'company._id', '').replace('members/', '')
    const remittanceTemplate = await submitTemplate(company, 'remittance')
    const emailDetails = get(remittanceTemplate, 'email') || {}
    const data = await submitRemittanceTemplate({
      receiver: get(voucher, 'notify.main.fn'),
      ...emailDetails,
    })

    const filesList = await submitRemittanceFiles([remittance._id])
    setEmailFiles(filesList)
    const filesMapped = filesList.map((f) => f.uuid)
    const notifyMain = get(voucher, 'notify.main.email.label')
    const notifyAdditional = get(voucher, 'notify.additional')
    const to = `${notifyMain} ${notifyAdditional && ',' + notifyAdditional}`
    setEmailTemplate(data.html)
    setEmailDetails({
      to: to,
      bcc: get(emailDetails, 'bcc'),
      from: get(emailDetails, 'from'),
      subject: get(emailDetails, 'subject'),
      attachments: filesMapped,
    })
    setEmailLines([remittance])
  })

  const selectionData = selection.map((s) => paymentRequestList.find((p) => get(p, '_id') === s))
  const selectionIDs = selectionData.map((s) => get(s, 'payee._id'))

  const filteredData = isEmpty(selectionIDs)
    ? paymentRequestList
    : paymentRequestList.filter((v) => selectionIDs.includes(get(v, 'payee._id')))
  const [creating, createFunc] = useSubmit(RemittanceApi.createWithLines)

  async function createWithLines() {
    const created = await createFunc(selection)
    if (created) {
      const win = window.open(`/#/purchasing/remittance/${created._key}/update`, '_blank')
      win.focus()
      setSelection([])
      fetch()
    }
  }

  useTitle('Remittances')

  return (
    <Remittance
      {...{
        list,
        fetching,
        fetch,
        visible,
        modalType,
        remittance,
        setRemittance,
        submitting,
        update,
        remove,
        removing,
        formRef,
        submit,
        onShow,
        onCancel,
        paymentRequestList,
        paymentRequestFetching,
        paymentRequestFetch,
        createWithLines,
        creating,
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
        onShowEmail,
        visibleEmail,
        onCancelEmail,
        emailTemplate,
        emailDetails,
        emailFiles,
        emailLines,
        selectionData,
        selectionIDs,
        filteredData,
        company,
        onChangeCompany,
        paymentRequestCompany,
        paymentRequestOnChangeCompany,
      }}
    />
  )
}

RemittanceCont.propTypes = {}
RemittanceCont.defaultProps = {}

export default withRouter(RemittanceCont)
